<template lang="pug">
.insights-leaderboard-widget-member
  .d-flex.align-items-center.max-w-full(v-if="deactivated")
    AppAvatar(
      size="speck"
      :avatar="avatarUrl"
    )
    .ellipsis {{ name }}
    i.hi.hi-info.ml-5(
      v-tooltip="tooltipOptions"
      :title="memberRemovedTooltip"
    )
  a.max-w-full.cursor-pointer(
    v-else
    @click.prevent="$emit('select')"
  )
    .d-flex.align-items-center
      AppAvatar(
        size="speck"
        :avatar="avatarUrl"
      )
      span.ellipsis {{ name }}
</template>

<script>
import AppAvatar from '~/components/AppAvatar.vue';

export default {
  name: 'InsightsMemberNameCell',
  components: {
    AppAvatar,
  },
  props: {
    avatarUrl: {
      type: String,
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    deactivated: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['select'],
  data: () => ({
    tooltipOptions: Object.freeze({ placement: 'top' }),
    memberRemovedTooltip: 'This member has been removed from the organization',
  }),
};
</script>
